<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Accounting</div><h2>Chart of accounts</h2></div>
            <div>
                <el-button size="small" type="primary" @click="syncFromBuildium">Sync from Buildium</el-button>
            </div>
        </div>

        <section class="page-section">
            <div class="form-inline">
                <div class="form-item">
                    <div class="form-item-label">Accounts Name</div>
                    <div class="form-item-input">
                        <el-input size="medium" class="w400" :clearable="true" v-model="params.name"/>
                    </div>
                </div>
                <div class="form-item">
                    <el-button size="medium" type="primary" @click="onSearch">{{ $t('post.search') }}</el-button>
                </div>
            </div>
        </section>

        <section class="page-section">
            <el-table :data="flattenedDataList" @selection-change="onSelectionChange" border>
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="AccountNumber" label="Account Number">
                    <template slot-scope="scope">
                        <span :style="{ paddingLeft: `${scope.row.indent * 20}px` }">
                            {{ scope.row.AccountNumber }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Name" label="Name">
                    <template slot-scope="scope">
                        <span :style="{ paddingLeft: `${scope.row.indent * 20}px` }">
                            {{ scope.row.Name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Type" label="Type"/>
                <el-table-column prop="DefaultAccountName" label="Default Account For"/>
                <el-table-column prop="CashFlowClassification" label="Cash Flow Classification"/>
                <el-table-column prop="Description" label="Note"/>
                <el-table-column prop="IsActive" label="Status">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsActive ? 'success' : 'danger'">
                            {{ scope.row.IsActive ? 'Active' : 'InActive' }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-button size="small" type="primary" :disabled="!selectionIds.length" @click="onBatchDelete">
                        {{ $t('common.batch_delete') }}
                    </el-button>
                </div>
                <el-pagination
                        background
                        layout="prev, pager, next, total"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="page"
                        @current-change="onPageChange"
                />
            </div>
        </section>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";

export default {
    name: "ChartOfAccounts",
    mixins: [Pagination],
    data() {
        return {
            autoSearch: true,
            params: {
                name: ''
            },
            flattenedDataList: [] // 展平的表格数据
        }
    },
    methods: {
        listApi() {
            return '/buildium/chart-of-accounts';
        },
        listParams() {
            return this.params;
        },
        syncFromBuildium() {
            const loading = this.$loading({
                lock: true,
                text: 'Synchronizing...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$api.get('/buildium/chart-of-accounts/sync').then(response => {
                this.$message.success('Sync completed');
                this.fetchList();
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                loading.close();
            });
        },
        processSubAccounts(subAccounts, parentIndent) {
            // 递归处理子账户数据，添加缩进层级
            let result = [];
            subAccounts.forEach(subAccount => {
                result.push({
                    ...subAccount,
                    indent: parentIndent + 1
                });
                if (subAccount.sub_accounts && subAccount.sub_accounts.length) {
                    result = result.concat(this.processSubAccounts(subAccount.sub_accounts, parentIndent + 1));
                }
            });
            return result;
        },
        onFinish(response) {
            const flattenedList = [];
            response.data.items.forEach(account => {
                // 添加主账户
                flattenedList.push({
                    ...account,
                    indent: 0 // 主账户缩进层级为 0
                });
                // 添加子账户
                if (account.sub_accounts && account.sub_accounts.length) {
                    flattenedList.push(...this.processSubAccounts(account.sub_accounts, 0));
                }
            });
            this.flattenedDataList = flattenedList;
        },
        onBatchDelete() {
            let ids = this.selectionIds.map(item => item.Id);
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                ApiService.delete('/buildium/rentals/properties/batch', {data: {ids}}).then(response => {
                    this.$message.success('Deleted successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            }).catch(() => {
                this.$message.info('Canceled');
            });
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<style scoped>

</style>
